<div class="card-header">
  <div class="headerRow">
    <nz-icon nzType="info-circle" class="header-icon" />
    <span><strong>{{'jsonimporter.runningConfig'|translateTA}}</strong>
      {{ headerText || ('jsonimporter.selectConfigHint'|translateTA) }}</span>
  </div>

  <div class="header-controls">
    <div class="tem-field header-field" *ngIf="uas.user.companylist.length > 1">
      <span class="tem-field-label">{{'jsonimporter.chooseCompany'|translateTA}}</span>
      <nz-select [(ngModel)]="codecompany" (ngModelChange)="getActiveCompanies()" nzShowSearch
        [nzPlaceHolder]="'jsonimporter.chooseCompany'|translateTA">
        <nz-option *ngFor="let data of uas.user.companylist" [nzValue]="data.codecompany"
          [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
      </nz-select>
    </div>

    <div class="header-buttons">
      <button nz-button nzType="primary" type="button" [nzLoading]="loadingConfigs" (click)="loadConfigs()">
        <nz-icon nzType="setting" />{{'jsonimporter.loadConfigs'|translateTA}}
      </button>
    </div>
  </div>
</div>

<div class="view-component">
  <nz-tabs class="custom-tabs">
    <nz-tab [nzTitle]="'jsonimporter.tabConfigs'|translateTA">
      <nz-spin [nzSpinning]="loadingConfigs">

        <nz-empty *ngIf="!configs.length && !loadingConfigs" nzNotFoundImage="simple"
          [nzNotFoundContent]="'jsonimporter.noConfigs'|translateTA"></nz-empty>

        <div class="card-grid">
          <div class="config-card" *ngFor="let conf of configs">
            <img class="config-card-image" [src]="conf.IMAGE || ''" (error)="conf.imageError = true"
              *ngIf="!conf.imageError; else noImage" alt="">
            <ng-template #noImage>
              <div class="no-image">
                <nz-icon nzType="file-image" />
              </div>
            </ng-template>

            <div class="integration-header">
              <span class="integration-name" nz-tooltip [nzTooltipTitle]="conf.NAME">
                {{ conf.NAME || ('jsonimporter.noName'|translateTA) }}</span>
            </div>

            <div class="param-info">
              <nz-icon nzType="control" />
              <span>{{ conf.config.parameters?.length || 0 }} {{'jsonimporter.paramCount'|translateTA}}</span>
            </div>

            <div class="card-actions-row">
              <button nz-button nzType="primary" type="button" class="execute-button"
                [disabled]="conf.status === 'processing'" [nzLoading]="conf.status === 'processing'"
                (click)="onExecute(conf)">
                <nz-icon *ngIf="conf.status === 'idle'" nzType="caret-right" />
                <nz-icon *ngIf="conf.status === 'success'" nzType="check-circle" />
                <nz-icon *ngIf="conf.status === 'error'" nzType="close-circle" />
                <span class="btn-label">
                  {{
                    conf.status === 'processing' ? ('jsonimporter.executing'|translateTA) :
                    conf.status === 'success' ? ('jsonimporter.done'|translateTA) :
                    conf.status === 'error' ? ('jsonimporter.error'|translateTA) : ('jsonimporter.execute'|translateTA)
                  }}
                </span>
              </button>
            </div>

            <div class="status-info">
              <div class="time-info" *ngIf="conf.duration">
                <nz-icon nzType="clock-circle" /> {{'jsonimporter.time'|translateTA}}: {{ conf.duration }}s
              </div>

              <div class="error-info" *ngIf="conf.errorMsg">
                <nz-icon nzType="exclamation-circle" class="error-icon" nz-tooltip [nzTooltipTitle]="conf.errorMsg" />
                <button nz-button nzType="link" nzSize="small" type="button" class="error-copy-link"
                  (click)="copyToClipboard(conf.errorMsg)">
                  {{'jsonimporter.copyError'|translateTA}}
                </button>
              </div>
            </div>
          </div>
        </div>

      </nz-spin>
    </nz-tab>
  </nz-tabs>
</div>

<!-- Dialogo para preencher parametros input (via NzModalService) -->
<ng-template #inputDialog let-data>
  <div class="param-modal">
    <h2 class="param-modal-title">{{'jsonimporter.fillParams'|translateTA}}</h2>

    <div class="param-modal-content">
      <nz-collapse>
        <nz-collapse-panel *ngFor="let param of data.parameters" [nzActive]="true"
          [nzHeader]="'@' + param.PARNAME"
          [nzExtra]="param.TYPE === 'I' ? ('jsonimporter.userInput'|translateTA) : ('jsonimporter.otherType'|translateTA)">

          <div class="param-input" *ngIf="param.TYPE !== 'D' && param.TYPE !== 'S'">
            <div class="tem-field full-width">
              <textarea *ngIf="isMultiline(param.VALUE)" nz-input rows="4" [(ngModel)]="param.VALUE"
                [placeholder]="('jsonimporter.valuePlaceholder'|translateTA) + ' @' + param.PARNAME"></textarea>

              <input *ngIf="!isMultiline(param.VALUE)" nz-input [(ngModel)]="param.VALUE"
                [placeholder]="('jsonimporter.valuePlaceholder'|translateTA) + ' @' + param.PARNAME" />
            </div>
          </div>

          <div class="param-input" *ngIf="param.TYPE === 'S'">
            <search-input-new [(ngModel)]="param.VALUE" [searchProperties]="{
                placeholder: ('jsonimporter.searchValue'|translateTA),
                size: 'large',
                showKey: true,
                disabled: false,
                entityName: param.ENTITYNAME.value,
                fields: {
                  keyField: param.KEYFIELD.value,
                  valueField: param.VALUEFIELD.value
                }
              }"></search-input-new>
          </div>

          <div class="param-input" *ngIf="param.TYPE === 'D'">
            <nz-upload [nzCustomRequest]="customUpload" nzName="arquivo" [nzShowUploadList]="true" [nzMultiple]="true"
              [nzWithCredentials]="false" [nzBeforeUpload]="beforeUpload" (nzChange)="onChange($event)">
              <button nz-button type="button">
                <nz-icon nzType="upload" />
                {{'jsonimporter.selectFile'|translateTA}}
              </button>
            </nz-upload>
            <nz-divider></nz-divider>
            <div class="directory-class">
              <button nz-button nzType="primary" type="button" [nzLoading]="loadingDirectory" (click)="openDirectory()">
                {{'jsonimporter.selectFolder'|translateTA}}
              </button>
              <p>{{'jsonimporter.directory'|translateTA}}: {{directoryPath}} |
                {{'jsonimporter.totalFiles'|translateTA}}: {{directoryfileList.length}}</p>
            </div>
          </div>

        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div class="param-modal-actions">
      <button nz-button type="button" (click)="closeDialog()">{{'cancel'|translateTA}}</button>
      <button nz-button nzType="primary" type="button" (click)="validateAndSubmit()">{{'jsonimporter.execute'|translateTA}}</button>
    </div>
  </div>
</ng-template>
